/** This indicates in which state the popup is currently, depending on the state the input will be
 * taken from the document or the selection.
 * If some content has just been generated the selection will automatically be moved to the generated blocks */
export var AiPopupState;
(function (AiPopupState) {
    /** no text in the document, draft actions are enabled */
    AiPopupState["EmptyDocument"] = "emptyDocument";
    /** has content but no selection, draft actions are enabled and document is used as input */
    AiPopupState["EmptySelection"] = "emptySelection";
    /** has content and selection, draft actions are enabled and selection is used as input */
    AiPopupState["ContentSelected"] = "contentSelected";
    /** content has been generated inside popup block, draft actions are disabled, generated content is selected and used as input */
    AiPopupState["ContentGenerated"] = "contentGenerated";
    /** content has been generated inline in the editor, draft actions are disabled, generated content is selected and used as input */
    AiPopupState["InlineContentGenerated"] = "inlineContentGenerated";
})(AiPopupState || (AiPopupState = {}));
/** The actions that can be triggered through AiCommand's */
export var AiPopupActions;
(function (AiPopupActions) {
    /** Replaces ai popup input value by pre-made prompt */
    AiPopupActions["ReplaceInput"] = "replaceInput";
    /** Execute prompt directly */
    AiPopupActions["Prompt"] = "prompt";
    /** Close popup and clear selection */
    AiPopupActions["ClosePopup"] = "closePopup";
    /** Replace selection with generated content */
    AiPopupActions["ReplaceSelection"] = "replaceSelection";
    /** Append generated content to selection */
    AiPopupActions["AppendSelection"] = "appendSelection";
    /** Discard changes */
    AiPopupActions["DiscardChanges"] = "discardChanges";
})(AiPopupActions || (AiPopupActions = {}));
/** How the result of the actions should be added to the document. */
export var AiCommandResultAction;
(function (AiCommandResultAction) {
    /** Replace the selection with the result */
    AiCommandResultAction["ReplaceSelection"] = "replaceSelection";
    /** Append the result to the selection */
    AiCommandResultAction["Append"] = "append";
})(AiCommandResultAction || (AiCommandResultAction = {}));
